<div class="modal-header">
    <h4 class="modal-title">Specify Excel File Name</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <form #fileForm="ngForm">
      <div class="form-floating mb-3 mt-3">
        <input type="text" class="form-control" id="fileName" name="filename" [(ngModel)]="name" placeholder="Enter a name for your Excel file" required
          minlength="3" #fileName="ngModel"/>
        <label for="fileName">Desired Excel File Name</label>
        <div *ngIf="fileName.invalid && fileName.touched" class="text-danger">
          <small *ngIf="fileName.errors?.['required']">File name is required.</small>
          <small *ngIf="fileName.errors?.['minlength']">File name must be at least 3 characters long.</small>
        </div>
      </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()"><i class="fa fa-regular fa-circle-xmark"></i> Cancel</button>
    <button type="button" class="btn btn-primary" (click)="submit()"[disabled]="fileForm.invalid"><i class="fa fa-solid fa-download"></i> Download Excel File</button>
</div>
  
  